import React from "react"
import BlockWrapper from "@yumgmbh/gatsby-theme-yum-components/src/components/technical/BlockWrapper"
import HeadlineEnhanced from "@yumgmbh/gatsby-theme-yum-components/src/components/molecules/HeadlineEnhanced"
import { Helmet } from "react-helmet"

import logo from "../../images/kio-logo.svg"
import Image from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Image"
import useScript from "../../hooks/useScript"

const MembershipBlock = ({ block }) => {
  const [loaded] = useScript(
    "https://secure.fundraisingbox.com/app/paymentJS?hash=d9gggwfj2qf5si7o"
  )
  return (
    <BlockWrapper block={block}>
      <div className="flex flex-row flex-wrap">
        <div className="w-full text-center px-grid">
          {block.headline && <HeadlineEnhanced headline={block.headline} />}
          <div className="relative">
            <div id="fbIframeDiv"></div>
            {/* <Helmet>
              <script
                type="text/javascript"
                src="https://secure.fundraisingbox.com/app/paymentJS?hash=d9gggwfj2qf5si7o"
              ></script>
            </Helmet> */}
            <Image
              className="right-0 p-4 ml-auto w-28 sm:absolute bottom-14"
              image={{
                filename: logo,
                title: "Zur KiO-Startseite",
                alt: "KiO - Kinderhilfe Organtransplantation",
              }}
            />
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.fundraisingbox.com/?utm_source=donation_form"
            >
              <img
                border="0"
                //style="border: 0 !important"
                src="https://secure.fundraisingbox.com/images/FundraisingBox-Logo-Widget.png"
                alt="FundraisingBox Logo"
              />
            </a>
          </div>
        </div>
      </div>
    </BlockWrapper>
  )
}

export default MembershipBlock
